import { PopoverItem, SelectionActionsFab } from '@enter/core';
import React from 'react';

export const ClaimListBatchActionsToolbar: React.FC<{
    selectedCount: number;
    onCloseout: () => void;
    onSuppressCoderRules: () => void;
    onRestoreCoderRules: () => void;
    disabled?: boolean;
}> = ({ selectedCount, onCloseout, onSuppressCoderRules, onRestoreCoderRules, disabled }) => (
    <SelectionActionsFab selectedCount={selectedCount} noun="claim" disabled={disabled}>
        <PopoverItem onClick={onCloseout} disabled={disabled}>
            Close out claims
        </PopoverItem>
        <PopoverItem onClick={onRestoreCoderRules} disabled={disabled}>
            Restore coder rules
        </PopoverItem>
        <PopoverItem onClick={onSuppressCoderRules} disabled={disabled}>
            Suppress coder rules
        </PopoverItem>
    </SelectionActionsFab>
);
